<template>
  <div class="row no-gutters">
    <template v-if="routemap.firstControlQA">
      <div class="col-6 mb-2 text-strong">
        {{ $t("QUALITY_CONTROL") }}:
      </div>
      <div class="col-6 mb-2">
        {{ routemap.firstControlQA }}
      </div>
    </template>
    <template v-if="routemap.firstControlTime">
      <div class="col-6 mb-2 text-strong">
        {{ $t("FIRST_CONTROL_OF_THE_DAY") }}:
      </div>
      <div class="col-6 mb-2">
        {{ routemap.firstControlTime }}
      </div>
    </template>

    <template v-if="routemap.lastControlTime">
      <div class="col-6 mb-2 text-strong">
        {{ $t("LAST_CONTROL_PERFORMED") }}:
      </div>
      <div class="col-6 mb-2">
        {{ routemap.lastControlTime }}
      </div>
    </template>

    <template>
      <div class="col-6 mb-2 text-strong">
        {{ $t("PERFORMED_CONTROLS_TODAY") }}:
      </div>
      <div class="col-6 mb-2">
        {{ routemap.controlsToday ? routemap.controlsToday : 0 }}
      </div>
    </template>

    <template>
      <div class="col-6 mb-2 text-strong">{{ $t("NEXT_PAUSE") }}:</div>
      <div class="col-6 mb-2">
        <span v-if="routemap.nextPause"
          >{{ routemap.nextPause.minutes }} {{ $t("MINUTES_FROM") }}
          {{ routemap.nextPause.from }} {{ $t("TO") }} {{ routemap.nextPause.to }}</span
        >
        <span v-else>{{ $t("THERE_IS_NO") }}</span>
      </div>
    </template>

    <template>
      <div class="col-6 mb-2 text-strong">{{ $t("PERFORMED_PAUSES_TODAY") }}:</div>
      <div class="col-6 mb-2">
        {{ routemap.pausesToday ? routemap.pausesToday : 0 }}
      </div>
    </template>

    <template
      v-if="routemap.performedChargingBy && routemap.performedChargingDate"
    >
      <div class="col-6 mb-2 text-strong">{{ $t("PERFORMED_CHARGING") }}:</div>
      <div class="col-6 mb-2">
        <span
          >{{ routemap.performedChargingBy }} {{ $t("ON") }}
          {{ routemap.performedChargingDate }}</span
        >
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    routemap: {
      required: true,
      type: Object
    }
  }
};
</script>
